import TypographyOverflow from '@liquidweb-dev/undercurrent/TypographyOverflow';

/**
 * The asset's domain, shown beneath its name so the real hostname stays
 * visible when a custom name is set.
 */
const DomainLine = ({ domain }: { domain: string }) => (
	<TypographyOverflow
		variant="label-md"
		sx={{ color: ({ vars }) => vars.palette.uc.text.weak }}
	>
		{domain}
	</TypographyOverflow>
);

export default DomainLine;
